module.exports = __webpack_public_path__ + "img/will.79accf2c.svg";